import { ApartmentEntry, ApartmentStatus } from '../../types/config';

export const inventoryDataYuvalim: ApartmentEntry[] = [
  {
    building: 'B1',
    number: 1,
    type: 'E2_gan',
    floor: 1,
    rooms: 5,
    area: 120,
    balconyArea: 173,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_E2_gan_select_floor1',
    nrId: 1,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    hasVideo: false,
    galleryCount: 1,
    floorPlanImage: 'floorplanE2G',
  },
  {
    building: 'B1',
    number: 3,
    type: 'C-4_gan',
    floor: 1,
    rooms: 4,
    area: 106,
    balconyArea: 0,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_C-4_gan_select_floor1',
    nrId: 2,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    hasVideo: false,
    galleryCount: 1,
    floorPlanImage: 'floorplanC4G',
  },
  {
    building: 'B1',
    number: 4,
    type: 'C-4',
    floor: 1,
    rooms: 4,
    area: 106,
    balconyArea: 24,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_C-4_select_floor1',
    nrId: 3,
    tourUrl: 'https://my.treedis.com/tour/c4',
    galleryType: 'galleryC4',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplanC4',
  },
  {
    building: 'B1',
    number: 6,
    type: 'E1_gan',
    floor: 1,
    rooms: 5,
    area: 127,
    balconyArea: 80,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_E1_gan_select_floor1',
    nrId: 4,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    hasVideo: false,
    galleryCount: 1,
    floorPlanImage: 'floorplanE1G',
  },
  {
    building: 'B1',
    number: 7,
    type: 'E2',
    floor: 2,
    rooms: 5,
    area: 120,
    balconyArea: 44,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_E2_select_floor2',
    nrId: 5,
    tourUrl: 'https://my.treedis.com/tour/e2-41869f1d',
    galleryType: 'galleryE2',
    hasVideo: true,
    galleryCount: 18,
    floorPlanImage: 'floorplanE2',
  },
  {
    building: 'B1',
    number: 12,
    type: 'E1',
    floor: 2,
    rooms: 5,
    area: 127,
    balconyArea: 48,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_E1_select_floor2',
    nrId: 6,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    hasVideo: false,
    galleryCount: 1,
    floorPlanImage: 'floorplanE1',
  },
  {
    building: 'B1',
    number: 13,
    type: 'E2',
    floor: 3,
    rooms: 5,
    area: 120,
    balconyArea: 44,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_E2_select_floor3',
    nrId: 7,
    tourUrl: 'https://my.treedis.com/tour/e2-41869f1d',
    galleryType: 'galleryE2',
    hasVideo: true,
    galleryCount: 18,
    floorPlanImage: 'floorplanE2',
  },
  {
    building: 'B1',
    number: 15,
    type: 'C-4',
    floor: 3,
    rooms: 4,
    area: 106,
    balconyArea: 24,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_C-4_select_floor3',
    nrId: 8,
    tourUrl: 'https://my.treedis.com/tour/c4',
    galleryType: 'galleryC4',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplanC4',
  },
  {
    building: 'B1',
    number: 16,
    type: 'C-4',
    floor: 3,
    rooms: 4,
    area: 106,
    balconyArea: 24,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_C-4_select_floor3',
    nrId: 9,
    tourUrl: 'https://my.treedis.com/tour/c4',
    galleryType: 'galleryC4',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplanC4',
  },
  {
    building: 'B1',
    number: 18,
    type: 'E1',
    floor: 3,
    rooms: 5,
    area: 127,
    balconyArea: 48,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_E1_select_floor3',
    nrId: 10,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    hasVideo: false,
    galleryCount: 1,
    floorPlanImage: 'floorplanE1',
  },
  {
    building: 'B1',
    number: 19,
    type: 'E2',
    floor: 4,
    rooms: 5,
    area: 120,
    balconyArea: 44,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_E2_select_floor4',
    nrId: 11,
    tourUrl: 'https://my.treedis.com/tour/e2-41869f1d',
    galleryType: 'galleryE2',
    hasVideo: true,
    galleryCount: 18,
    floorPlanImage: 'floorplanE2',
  },
  {
    building: 'B1',
    number: 24,
    type: 'E1',
    floor: 4,
    rooms: 5,
    area: 127,
    balconyArea: 48,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_E1_select_floor4',
    nrId: 12,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    hasVideo: false,
    galleryCount: 1,
    floorPlanImage: 'floorplanE1',
  },
  {
    building: 'B1',
    number: 28,
    type: 'C-4',
    floor: 5,
    rooms: 4,
    area: 106,
    balconyArea: 24,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_C-4_select_floor5',
    nrId: 13,
    tourUrl: 'https://my.treedis.com/tour/c4',
    galleryType: 'galleryC4',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplanC4',
  },
  {
    building: 'B1',
    number: 30,
    type: 'E1',
    floor: 5,
    rooms: 5,
    area: 127,
    balconyArea: 48,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_E1_select_floor5',
    nrId: 14,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    hasVideo: false,
    galleryCount: 1,
    floorPlanImage: 'floorplanE1',
  },
  {
    building: 'B1',
    number: 31,
    type: 'E2',
    floor: 6,
    rooms: 5,
    area: 120,
    balconyArea: 44,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_E2_select_floor6',
    nrId: 15,
    tourUrl: 'https://my.treedis.com/tour/e2-41869f1d',
    galleryType: 'galleryE2',
    hasVideo: true,
    galleryCount: 18,
    floorPlanImage: 'floorplanE2',
  },
  {
    building: 'B1',
    number: 36,
    type: 'E1',
    floor: 6,
    rooms: 5,
    area: 127,
    balconyArea: 48,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_E1_select_floor6',
    nrId: 16,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    hasVideo: false,
    galleryCount: 1,
    floorPlanImage: 'floorplanE1',
  },
  {
    building: 'B1',
    number: 37,
    type: 'E2',
    floor: 7,
    rooms: 5,
    area: 120,
    balconyArea: 44,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_E2_select_floor7',
    nrId: 17,
    tourUrl: 'https://my.treedis.com/tour/e2-41869f1d',
    galleryType: 'galleryE2',
    hasVideo: true,
    galleryCount: 18,
    floorPlanImage: 'floorplanE2',
  },
  {
    building: 'B1',
    number: 39,
    type: 'C-4',
    floor: 7,
    rooms: 4,
    area: 106,
    balconyArea: 24,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_C-4_select_floor7',
    nrId: 18,
    tourUrl: 'https://my.treedis.com/tour/c4',
    galleryType: 'galleryC4',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplanC4',
  },
  {
    building: 'B1',
    number: 40,
    type: 'C-4',
    floor: 7,
    rooms: 4,
    area: 106,
    balconyArea: 24,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_C-4_select_floor7',
    nrId: 19,
    tourUrl: 'https://my.treedis.com/tour/c4',
    galleryType: 'galleryC4',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplanC4',
  },
  {
    building: 'B1',
    number: 42,
    type: 'E1',
    floor: 7,
    rooms: 5,
    area: 127,
    balconyArea: 48,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_E1_select_floor7',
    nrId: 20,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    hasVideo: false,
    galleryCount: 1,
    floorPlanImage: 'floorplanE1',
  },
  {
    building: 'B1',
    number: 43,
    type: 'E2',
    floor: 8,
    rooms: 5,
    area: 120,
    balconyArea: 44,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_E2_select_floor8',
    nrId: 21,
    tourUrl: 'https://my.treedis.com/tour/e2-41869f1d',
    galleryType: 'galleryE2',
    hasVideo: true,
    galleryCount: 18,
    floorPlanImage: 'floorplanE2',
  },
  {
    building: 'B1',
    number: 46,
    type: 'C-4',
    floor: 8,
    rooms: 4,
    area: 106,
    balconyArea: 24,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_C-4_select_floor8',
    nrId: 22,
    tourUrl: 'https://my.treedis.com/tour/c4',
    galleryType: 'galleryC4',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplanC4',
  },
  {
    building: 'B1',
    number: 48,
    type: 'E1',
    floor: 8,
    rooms: 5,
    area: 127,
    balconyArea: 48,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_E1_select_floor8',
    nrId: 23,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    hasVideo: false,
    galleryCount: 1,
    floorPlanImage: 'floorplanE1',
  },
  {
    building: 'B1',
    number: 49,
    type: 'E2',
    floor: 9,
    rooms: 5,
    area: 120,
    balconyArea: 44,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_E2_select_floor9',
    nrId: 24,
    tourUrl: 'https://my.treedis.com/tour/e2-41869f1d',
    galleryType: 'galleryE2',
    hasVideo: true,
    galleryCount: 18,
    floorPlanImage: 'floorplanE2',
  },
  {
    building: 'B1',
    number: 52,
    type: 'C-4',
    floor: 9,
    rooms: 4,
    area: 106,
    balconyArea: 24,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_C-4_select_floor9',
    nrId: 25,
    tourUrl: 'https://my.treedis.com/tour/c4',
    galleryType: 'galleryC4',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplanC4',
  },
  {
    building: 'B1',
    number: 54,
    type: 'E1',
    floor: 9,
    rooms: 5,
    area: 127,
    balconyArea: 48,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_E1_select_floor9',
    nrId: 26,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    hasVideo: false,
    galleryCount: 1,
    floorPlanImage: 'floorplanE1',
  },
  {
    building: 'B1',
    number: 55,
    type: 'E2',
    floor: 10,
    rooms: 5,
    area: 120,
    balconyArea: 44,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_E2_select_floor10',
    nrId: 27,
    tourUrl: 'https://my.treedis.com/tour/e2-41869f1d',
    galleryType: 'galleryE2',
    hasVideo: true,
    galleryCount: 18,
    floorPlanImage: 'floorplanE2',
  },
  {
    building: 'B1',
    number: 58,
    type: 'C-4',
    floor: 10,
    rooms: 4,
    area: 106,
    balconyArea: 24,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_C-4_select_floor10',
    nrId: 28,
    tourUrl: 'https://my.treedis.com/tour/c4',
    galleryType: 'galleryC4',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplanC4',
  },
  {
    building: 'B1',
    number: 60,
    type: 'E1',
    floor: 10,
    rooms: 5,
    area: 127,
    balconyArea: 48,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_E1_select_floor10',
    nrId: 29,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    hasVideo: false,
    galleryCount: 1,
    floorPlanImage: 'floorplanE1',
  },
  {
    building: 'B1',
    number: 61,
    type: 'E2',
    floor: 11,
    rooms: 5,
    area: 120,
    balconyArea: 44,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_E2_select_floor11',
    nrId: 30,
    tourUrl: 'https://my.treedis.com/tour/e2-41869f1d',
    galleryType: 'galleryE2',
    hasVideo: true,
    galleryCount: 18,
    floorPlanImage: 'floorplanE2',
  },
  {
    building: 'B1',
    number: 64,
    type: 'C-4',
    floor: 11,
    rooms: 4,
    area: 106,
    balconyArea: 24,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_C-4_select_floor11',
    nrId: 31,
    tourUrl: 'https://my.treedis.com/tour/c4',
    galleryType: 'galleryC4',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplanC4',
  },
  {
    building: 'B1',
    number: 66,
    type: 'E1',
    floor: 11,
    rooms: 5,
    area: 127,
    balconyArea: 48,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_E1_select_floor11',
    nrId: 32,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    hasVideo: false,
    galleryCount: 1,
    floorPlanImage: 'floorplanE1',
  },
  {
    building: 'B1',
    number: 70,
    type: 'C-4',
    floor: 12,
    rooms: 4,
    area: 106,
    balconyArea: 24,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_C-4_select_floor12',
    nrId: 33,
    tourUrl: 'https://my.treedis.com/tour/c4',
    galleryType: 'galleryC4',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplanC4',
  },
  {
    building: 'B1',
    number: 72,
    type: 'E1',
    floor: 12,
    rooms: 5,
    area: 127,
    balconyArea: 48,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_E1_select_floor12',
    nrId: 34,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    hasVideo: false,
    galleryCount: 1,
    floorPlanImage: 'floorplanE1',
  },
  {
    building: 'B1',
    number: 73,
    type: 'E2',
    floor: 13,
    rooms: 5,
    area: 120,
    balconyArea: 44,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_E2_select_floor13',
    nrId: 35,
    tourUrl: 'https://my.treedis.com/tour/e2-41869f1d',
    galleryType: 'galleryE2',
    hasVideo: true,
    galleryCount: 18,
    floorPlanImage: 'floorplanE2',
  },
  {
    building: 'B1',
    number: 75,
    type: 'C-4',
    floor: 13,
    rooms: 4,
    area: 106,
    balconyArea: 24,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_C-4_select_floor13',
    nrId: 36,
    tourUrl: 'https://my.treedis.com/tour/c4',
    galleryType: 'galleryC4',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplanC4',
  },
  {
    building: 'B1',
    number: 76,
    type: 'C-4',
    floor: 13,
    rooms: 4,
    area: 106,
    balconyArea: 24,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_C-4_select_floor13',
    nrId: 37,
    tourUrl: 'https://my.treedis.com/tour/c4',
    galleryType: 'galleryC4',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplanC4',
  },
  {
    building: 'B1',
    number: 78,
    type: 'E1',
    floor: 13,
    rooms: 5,
    area: 127,
    balconyArea: 48,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_E1_select_floor13',
    nrId: 38,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    hasVideo: false,
    galleryCount: 1,
    floorPlanImage: 'floorplanE1',
  },
  {
    building: 'B1',
    number: 79,
    type: 'E2',
    floor: 14,
    rooms: 5,
    area: 120,
    balconyArea: 44,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_E2_select_floor14',
    nrId: 39,
    tourUrl: 'https://my.treedis.com/tour/e2-41869f1d',
    galleryType: 'galleryE2',
    hasVideo: true,
    galleryCount: 18,
    floorPlanImage: 'floorplanE2',
  },
  {
    building: 'B1',
    number: 81,
    type: 'C-4',
    floor: 14,
    rooms: 4,
    area: 106,
    balconyArea: 24,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_C-4_select_floor14',
    nrId: 40,
    tourUrl: 'https://my.treedis.com/tour/c4',
    galleryType: 'galleryC4',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplanC4',
  },
  {
    building: 'B1',
    number: 82,
    type: 'C-4',
    floor: 14,
    rooms: 4,
    area: 106,
    balconyArea: 24,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_C-4_select_floor14',
    nrId: 41,
    tourUrl: 'https://my.treedis.com/tour/c4',
    galleryType: 'galleryC4',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplanC4',
  },
  {
    building: 'B1',
    number: 84,
    type: 'E1',
    floor: 14,
    rooms: 5,
    area: 127,
    balconyArea: 48,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_E1_select_floor14',
    nrId: 42,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    hasVideo: false,
    galleryCount: 1,
    floorPlanImage: 'floorplanE1',
  },
  {
    building: 'B1',
    number: 85,
    type: 'E2',
    floor: 15,
    rooms: 5,
    area: 120,
    balconyArea: 44,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_E2_select_floor15',
    nrId: 43,
    tourUrl: 'https://my.treedis.com/tour/e2-41869f1d',
    galleryType: 'galleryE2',
    hasVideo: true,
    galleryCount: 18,
    floorPlanImage: 'floorplanE2',
  },
  {
    building: 'B1',
    number: 87,
    type: 'C-4',
    floor: 15,
    rooms: 4,
    area: 106,
    balconyArea: 24,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_C-4_select_floor15',
    nrId: 44,
    tourUrl: 'https://my.treedis.com/tour/c4',
    galleryType: 'galleryC4',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplanC4',
  },
  {
    building: 'B1',
    number: 88,
    type: 'C-4',
    floor: 15,
    rooms: 4,
    area: 106,
    balconyArea: 24,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_C-4_select_floor15',
    nrId: 45,
    tourUrl: 'https://my.treedis.com/tour/c4',
    galleryType: 'galleryC4',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplanC4',
  },
  {
    building: 'B1',
    number: 90,
    type: 'E1',
    floor: 15,
    rooms: 5,
    area: 127,
    balconyArea: 48,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_E1_select_floor15',
    nrId: 46,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    hasVideo: false,
    galleryCount: 1,
    floorPlanImage: 'floorplanE1',
  },
  {
    building: 'B1',
    number: 91,
    type: 'E2',
    floor: 16,
    rooms: 5,
    area: 120,
    balconyArea: 44,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_E2_select_floor16',
    nrId: 47,
    tourUrl: 'https://my.treedis.com/tour/e2-41869f1d',
    galleryType: 'galleryE2',
    hasVideo: true,
    galleryCount: 18,
    floorPlanImage: 'floorplanE2',
  },
  {
    building: 'B1',
    number: 92,
    type: 'A-3',
    floor: 16,
    rooms: 3,
    area: 84,
    balconyArea: 15,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_A-3_select_floor16',
    nrId: 48,
    tourUrl: 'https://my.treedis.com/tour/a3',
    galleryType: 'galleryA3',
    hasVideo: true,
    galleryCount: 11,
    floorPlanImage: 'floorplanA3',
  },
  {
    building: 'B1',
    number: 93,
    type: 'C-4',
    floor: 16,
    rooms: 4,
    area: 106,
    balconyArea: 24,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_C-4_select_floor16',
    nrId: 49,
    tourUrl: 'https://my.treedis.com/tour/c4',
    galleryType: 'galleryC4',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplanC4',
  },
  {
    building: 'B1',
    number: 94,
    type: 'C-4',
    floor: 16,
    rooms: 4,
    area: 106,
    balconyArea: 24,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_C-4_select_floor16',
    nrId: 50,
    tourUrl: 'https://my.treedis.com/tour/c4',
    galleryType: 'galleryC4',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplanC4',
  },
  {
    building: 'B1',
    number: 95,
    type: 'A-3',
    floor: 16,
    rooms: 3,
    area: 84,
    balconyArea: 15,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_A-3_select_floor16',
    nrId: 51,
    tourUrl: 'https://my.treedis.com/tour/a3',
    galleryType: 'galleryA3',
    hasVideo: true,
    galleryCount: 11,
    floorPlanImage: 'floorplanA3',
  },
  {
    building: 'B1',
    number: 96,
    type: 'E1',
    floor: 16,
    rooms: 5,
    area: 127,
    balconyArea: 48,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_E1_select_floor16',
    nrId: 52,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    hasVideo: false,
    galleryCount: 1,
    floorPlanImage: 'floorplanE1',
  },
  {
    building: 'B1',
    number: 97,
    type: 'E2',
    floor: 17,
    rooms: 5,
    area: 120,
    balconyArea: 44,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_E2_select_floor17',
    nrId: 53,
    tourUrl: 'https://my.treedis.com/tour/e2-41869f1d',
    galleryType: 'galleryE2',
    hasVideo: true,
    galleryCount: 18,
    floorPlanImage: 'floorplanE2',
  },
  {
    building: 'B1',
    number: 98,
    type: 'A-3',
    floor: 17,
    rooms: 3,
    area: 84,
    balconyArea: 15,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_A-3_select_floor17',
    nrId: 54,
    tourUrl: 'https://my.treedis.com/tour/a3',
    galleryType: 'galleryA3',
    hasVideo: true,
    galleryCount: 11,
    floorPlanImage: 'floorplanA3',
  },
  {
    building: 'B1',
    number: 99,
    type: 'C-4',
    floor: 17,
    rooms: 4,
    area: 106,
    balconyArea: 24,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_C-4_select_floor17',
    nrId: 55,
    tourUrl: 'https://my.treedis.com/tour/c4',
    galleryType: 'galleryC4',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplanC4',
  },
  {
    building: 'B1',
    number: 100,
    type: 'C-4',
    floor: 17,
    rooms: 4,
    area: 106,
    balconyArea: 24,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_C-4_select_floor17',
    nrId: 56,
    tourUrl: 'https://my.treedis.com/tour/c4',
    galleryType: 'galleryC4',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplanC4',
  },
  {
    building: 'B1',
    number: 101,
    type: 'A-3',
    floor: 17,
    rooms: 3,
    area: 84,
    balconyArea: 15,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_A-3_select_floor17',
    nrId: 57,
    tourUrl: 'https://my.treedis.com/tour/a3',
    galleryType: 'galleryA3',
    hasVideo: true,
    galleryCount: 11,
    floorPlanImage: 'floorplanA3',
  },
  {
    building: 'B1',
    number: 102,
    type: 'E1',
    floor: 17,
    rooms: 5,
    area: 127,
    balconyArea: 48,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_E1_select_floor17',
    nrId: 58,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    hasVideo: false,
    galleryCount: 1,
    floorPlanImage: 'floorplanE1',
  },
  {
    building: 'B1',
    number: 103,
    type: 'E2',
    floor: 18,
    rooms: 5,
    area: 120,
    balconyArea: 44,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_E2_select_floor18',
    nrId: 59,
    tourUrl: 'https://my.treedis.com/tour/e2-41869f1d',
    galleryType: 'galleryE2',
    hasVideo: true,
    galleryCount: 18,
    floorPlanImage: 'floorplanE2',
  },
  {
    building: 'B1',
    number: 104,
    type: 'A-3',
    floor: 18,
    rooms: 3,
    area: 84,
    balconyArea: 15,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_A-3_select_floor18',
    nrId: 60,
    tourUrl: 'https://my.treedis.com/tour/a3',
    galleryType: 'galleryA3',
    hasVideo: true,
    galleryCount: 11,
    floorPlanImage: 'floorplanA3',
  },
  {
    building: 'B1',
    number: 105,
    type: 'C-4',
    floor: 18,
    rooms: 4,
    area: 106,
    balconyArea: 24,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_C-4_select_floor18',
    nrId: 61,
    tourUrl: 'https://my.treedis.com/tour/c4',
    galleryType: 'galleryC4',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplanC4',
  },
  {
    building: 'B1',
    number: 106,
    type: 'C-4',
    floor: 18,
    rooms: 4,
    area: 106,
    balconyArea: 24,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_C-4_select_floor18',
    nrId: 62,
    tourUrl: 'https://my.treedis.com/tour/c4',
    galleryType: 'galleryC4',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplanC4',
  },
  {
    building: 'B1',
    number: 107,
    type: 'A-3',
    floor: 18,
    rooms: 3,
    area: 84,
    balconyArea: 15,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_A-3_select_floor18',
    nrId: 63,
    tourUrl: 'https://my.treedis.com/tour/a3',
    galleryType: 'galleryA3',
    hasVideo: true,
    galleryCount: 11,
    floorPlanImage: 'floorplanA3',
  },
  {
    building: 'B1',
    number: 109,
    type: 'E2',
    floor: 19,
    rooms: 5,
    area: 120,
    balconyArea: 44,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_E2_select_floor19',
    nrId: 64,
    tourUrl: 'https://my.treedis.com/tour/e2-41869f1d',
    galleryType: 'galleryE2',
    hasVideo: true,
    galleryCount: 18,
    floorPlanImage: 'floorplanE2',
  },
  {
    building: 'B1',
    number: 110,
    type: 'A-3',
    floor: 19,
    rooms: 3,
    area: 84,
    balconyArea: 15,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_A-3_select_floor19',
    nrId: 65,
    tourUrl: 'https://my.treedis.com/tour/a3',
    galleryType: 'galleryA3',
    hasVideo: true,
    galleryCount: 11,
    floorPlanImage: 'floorplanA3',
  },
  {
    building: 'B1',
    number: 111,
    type: 'C-4',
    floor: 19,
    rooms: 4,
    area: 106,
    balconyArea: 24,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_C-4_select_floor19',
    nrId: 66,
    tourUrl: 'https://my.treedis.com/tour/c4',
    galleryType: 'galleryC4',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplanC4',
  },
  {
    building: 'B1',
    number: 112,
    type: 'C-4',
    floor: 19,
    rooms: 4,
    area: 106,
    balconyArea: 24,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_C-4_select_floor19',
    nrId: 67,
    tourUrl: 'https://my.treedis.com/tour/c4',
    galleryType: 'galleryC4',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplanC4',
  },
  {
    building: 'B1',
    number: 113,
    type: 'A-3',
    floor: 19,
    rooms: 3,
    area: 84,
    balconyArea: 15,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_A-3_select_floor19',
    nrId: 68,
    tourUrl: 'https://my.treedis.com/tour/a3',
    galleryType: 'galleryA3',
    hasVideo: true,
    galleryCount: 11,
    floorPlanImage: 'floorplanA3',
  },
  {
    building: 'B1',
    number: 114,
    type: 'E1',
    floor: 19,
    rooms: 5,
    area: 127,
    balconyArea: 48,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_E1_select_floor19',
    nrId: 69,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    hasVideo: false,
    galleryCount: 1,
    floorPlanImage: 'floorplanE1',
  },
  {
    building: 'B1',
    number: 115,
    type: 'E2',
    floor: 20,
    rooms: 5,
    area: 120,
    balconyArea: 44,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_E2_select_floor20',
    nrId: 70,
    tourUrl: 'https://my.treedis.com/tour/e2-41869f1d',
    galleryType: 'galleryE2',
    hasVideo: true,
    galleryCount: 18,
    floorPlanImage: 'floorplanE2',
  },
  {
    building: 'B1',
    number: 116,
    type: 'A-3',
    floor: 20,
    rooms: 3,
    area: 84,
    balconyArea: 15,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_A-3_select_floor20',
    nrId: 71,
    tourUrl: 'https://my.treedis.com/tour/a3',
    galleryType: 'galleryA3',
    hasVideo: true,
    galleryCount: 11,
    floorPlanImage: 'floorplanA3',
  },
  {
    building: 'B1',
    number: 117,
    type: 'C-4',
    floor: 20,
    rooms: 4,
    area: 106,
    balconyArea: 24,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_C-4_select_floor20',
    nrId: 72,
    tourUrl: 'https://my.treedis.com/tour/c4',
    galleryType: 'galleryC4',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplanC4',
  },
  {
    building: 'B1',
    number: 118,
    type: 'C-4',
    floor: 20,
    rooms: 4,
    area: 106,
    balconyArea: 24,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_C-4_select_floor20',
    nrId: 73,
    tourUrl: 'https://my.treedis.com/tour/c4',
    galleryType: 'galleryC4',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplanC4',
  },
  {
    building: 'B1',
    number: 119,
    type: 'A-3',
    floor: 20,
    rooms: 3,
    area: 84,
    balconyArea: 15,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_A-3_select_floor20',
    nrId: 74,
    tourUrl: 'https://my.treedis.com/tour/a3',
    galleryType: 'galleryA3',
    hasVideo: true,
    galleryCount: 11,
    floorPlanImage: 'floorplanA3',
  },
  {
    building: 'B1',
    number: 121,
    type: 'E2',
    floor: 21,
    rooms: 5,
    area: 120,
    balconyArea: 44,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_E2_select_floor21',
    nrId: 75,
    tourUrl: 'https://my.treedis.com/tour/e2-41869f1d',
    galleryType: 'galleryE2',
    hasVideo: true,
    galleryCount: 18,
    floorPlanImage: 'floorplanE2',
  },
  {
    building: 'B1',
    number: 122,
    type: 'A-3',
    floor: 21,
    rooms: 3,
    area: 84,
    balconyArea: 15,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_A-3_select_floor21',
    nrId: 76,
    tourUrl: 'https://my.treedis.com/tour/a3',
    galleryType: 'galleryA3',
    hasVideo: true,
    galleryCount: 11,
    floorPlanImage: 'floorplanA3',
  },
  {
    building: 'B1',
    number: 123,
    type: 'C-4',
    floor: 21,
    rooms: 4,
    area: 106,
    balconyArea: 24,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_C-4_select_floor21',
    nrId: 77,
    tourUrl: 'https://my.treedis.com/tour/c4',
    galleryType: 'galleryC4',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplanC4',
  },
  {
    building: 'B1',
    number: 124,
    type: 'C-4',
    floor: 21,
    rooms: 4,
    area: 106,
    balconyArea: 24,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_C-4_select_floor21',
    nrId: 78,
    tourUrl: 'https://my.treedis.com/tour/c4',
    galleryType: 'galleryC4',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplanC4',
  },
  {
    building: 'B1',
    number: 125,
    type: 'A-3',
    floor: 21,
    rooms: 3,
    area: 84,
    balconyArea: 15,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_A-3_select_floor21',
    nrId: 79,
    tourUrl: 'https://my.treedis.com/tour/a3',
    galleryType: 'galleryA3',
    hasVideo: true,
    galleryCount: 11,
    floorPlanImage: 'floorplanA3',
  },
  {
    building: 'B1',
    number: 126,
    type: 'E1',
    floor: 21,
    rooms: 5,
    area: 127,
    balconyArea: 48,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B1_E1_select_floor21',
    nrId: 80,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    hasVideo: false,
    galleryCount: 1,
    floorPlanImage: 'floorplanE1',
  },
  {
    building: 'B2',
    number: 3,
    type: 'E3',
    floor: 2,
    rooms: 5,
    area: 124,
    balconyArea: 42,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_E3_select_floor2',
    nrId: 81,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    hasVideo: false,
    galleryCount: 1,
    floorPlanImage: 'floorplanE3',
  },
  {
    building: 'B2',
    number: 4,
    type: 'E',
    floor: 2,
    rooms: 5,
    area: 124,
    balconyArea: 45,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_E_select_floor2',
    nrId: 82,
    tourUrl: 'https://my.treedis.com/tour/e-67a61a8d',
    galleryType: 'galleryE',
    hasVideo: true,
    galleryCount: 23,
    floorPlanImage: 'floorplanE',
  },
  {
    building: 'B2',
    number: 9,
    type: 'E3',
    floor: 3,
    rooms: 5,
    area: 124,
    balconyArea: 42,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_E3_select_floor3',
    nrId: 83,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    hasVideo: false,
    galleryCount: 1,
    floorPlanImage: 'floorplanE3',
  },
  {
    building: 'B2',
    number: 15,
    type: 'E3',
    floor: 4,
    rooms: 5,
    area: 124,
    balconyArea: 42,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_E3_select_floor4',
    nrId: 84,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    hasVideo: false,
    galleryCount: 1,
    floorPlanImage: 'floorplanE3',
  },
  {
    building: 'B2',
    number: 21,
    type: 'E3',
    floor: 5,
    rooms: 5,
    area: 124,
    balconyArea: 42,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_E3_select_floor5',
    nrId: 85,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    hasVideo: false,
    galleryCount: 1,
    floorPlanImage: 'floorplanE3',
  },
  {
    building: 'B2',
    number: 22,
    type: 'E',
    floor: 5,
    rooms: 5,
    area: 124,
    balconyArea: 45,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_E_select_floor5',
    nrId: 86,
    tourUrl: 'https://my.treedis.com/tour/e-67a61a8d',
    galleryType: 'galleryE',
    hasVideo: true,
    galleryCount: 23,
    floorPlanImage: 'floorplanE',
  },
  {
    building: 'B2',
    number: 27,
    type: 'E3',
    floor: 6,
    rooms: 5,
    area: 124,
    balconyArea: 42,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_E3_select_floor6',
    nrId: 87,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    hasVideo: false,
    galleryCount: 1,
    floorPlanImage: 'floorplanE3',
  },
  {
    building: 'B2',
    number: 28,
    type: 'E',
    floor: 6,
    rooms: 5,
    area: 124,
    balconyArea: 45,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_E_select_floor6',
    nrId: 88,
    tourUrl: 'https://my.treedis.com/tour/e-67a61a8d',
    galleryType: 'galleryE',
    hasVideo: true,
    galleryCount: 23,
    floorPlanImage: 'floorplanE',
  },
  {
    building: 'B2',
    number: 30,
    type: 'C-4',
    floor: 6,
    rooms: 4,
    area: 106,
    balconyArea: 24,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_C-4_select_floor6',
    nrId: 89,
    tourUrl: 'https://my.treedis.com/tour/c4',
    galleryType: 'galleryC4',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplanC4',
  },
  {
    building: 'B2',
    number: 31,
    type: 'C-4',
    floor: 7,
    rooms: 4,
    area: 106,
    balconyArea: 24,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_C-4_select_floor7',
    nrId: 90,
    tourUrl: 'https://my.treedis.com/tour/c4',
    galleryType: 'galleryC4',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplanC4',
  },
  {
    building: 'B2',
    number: 33,
    type: 'E3',
    floor: 7,
    rooms: 5,
    area: 124,
    balconyArea: 42,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_E3_select_floor7',
    nrId: 91,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    hasVideo: false,
    galleryCount: 1,
    floorPlanImage: 'floorplanE3',
  },
  {
    building: 'B2',
    number: 34,
    type: 'E',
    floor: 7,
    rooms: 5,
    area: 124,
    balconyArea: 45,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_E_select_floor7',
    nrId: 92,
    tourUrl: 'https://my.treedis.com/tour/e-67a61a8d',
    galleryType: 'galleryE',
    hasVideo: true,
    galleryCount: 23,
    floorPlanImage: 'floorplanE',
  },
  {
    building: 'B2',
    number: 39,
    type: 'E3',
    floor: 8,
    rooms: 5,
    area: 124,
    balconyArea: 42,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_E3_select_floor8',
    nrId: 93,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    hasVideo: false,
    galleryCount: 1,
    floorPlanImage: 'floorplanE3',
  },
  {
    building: 'B2',
    number: 40,
    type: 'E',
    floor: 8,
    rooms: 5,
    area: 124,
    balconyArea: 45,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_E_select_floor8',
    nrId: 94,
    tourUrl: 'https://my.treedis.com/tour/e-67a61a8d',
    galleryType: 'galleryE',
    hasVideo: true,
    galleryCount: 23,
    floorPlanImage: 'floorplanE',
  },
  {
    building: 'B2',
    number: 43,
    type: 'C-4',
    floor: 9,
    rooms: 4,
    area: 106,
    balconyArea: 24,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_C-4_select_floor9',
    nrId: 95,
    tourUrl: 'https://my.treedis.com/tour/c4',
    galleryType: 'galleryC4',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplanC4',
  },
  {
    building: 'B2',
    number: 45,
    type: 'E3',
    floor: 9,
    rooms: 5,
    area: 124,
    balconyArea: 42,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_E3_select_floor9',
    nrId: 96,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    hasVideo: false,
    galleryCount: 1,
    floorPlanImage: 'floorplanE3',
  },
  {
    building: 'B2',
    number: 49,
    type: 'C-4',
    floor: 10,
    rooms: 4,
    area: 106,
    balconyArea: 24,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_C-4_select_floor10',
    nrId: 97,
    tourUrl: 'https://my.treedis.com/tour/c4',
    galleryType: 'galleryC4',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplanC4',
  },
  {
    building: 'B2',
    number: 50,
    type: 'A1',
    floor: 10,
    rooms: 4,
    area: 92,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_A1_select_floor10',
    nrId: 98,
    tourUrl: 'https://my.treedis.com/tour/a1-42e35d92',
    galleryType: 'galleryA1',
    hasVideo: true,
    galleryCount: 18,
    floorPlanImage: 'floorplanA1',
  },
  {
    building: 'B2',
    number: 51,
    type: 'E3',
    floor: 10,
    rooms: 5,
    area: 124,
    balconyArea: 42,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_E3_select_floor10',
    nrId: 99,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    hasVideo: false,
    galleryCount: 1,
    floorPlanImage: 'floorplanE3',
  },
  {
    building: 'B2',
    number: 57,
    type: 'E3',
    floor: 11,
    rooms: 5,
    area: 124,
    balconyArea: 42,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_E3_select_floor11',
    nrId: 100,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    hasVideo: false,
    galleryCount: 1,
    floorPlanImage: 'floorplanE3',
  },
  {
    building: 'B2',
    number: 58,
    type: 'E',
    floor: 11,
    rooms: 5,
    area: 124,
    balconyArea: 45,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_E_select_floor11',
    nrId: 101,
    tourUrl: 'https://my.treedis.com/tour/e-67a61a8d',
    galleryType: 'galleryE',
    hasVideo: true,
    galleryCount: 23,
    floorPlanImage: 'floorplanE',
  },
  {
    building: 'B2',
    number: 60,
    type: 'C-4',
    floor: 11,
    rooms: 4,
    area: 106,
    balconyArea: 24,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_C-4_select_floor11',
    nrId: 102,
    tourUrl: 'https://my.treedis.com/tour/c4',
    galleryType: 'galleryC4',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplanC4',
  },
  {
    building: 'B2',
    number: 62,
    type: 'A1',
    floor: 12,
    rooms: 4,
    area: 92,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_A1_select_floor12',
    nrId: 103,
    tourUrl: 'https://my.treedis.com/tour/a1-42e35d92',
    galleryType: 'galleryA1',
    hasVideo: true,
    galleryCount: 18,
    floorPlanImage: 'floorplanA1',
  },
  {
    building: 'B2',
    number: 63,
    type: 'E3',
    floor: 12,
    rooms: 5,
    area: 124,
    balconyArea: 42,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_E3_select_floor12',
    nrId: 104,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    hasVideo: false,
    galleryCount: 1,
    floorPlanImage: 'floorplanE3',
  },
  {
    building: 'B2',
    number: 64,
    type: 'E',
    floor: 12,
    rooms: 5,
    area: 124,
    balconyArea: 45,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_E_select_floor12',
    nrId: 105,
    tourUrl: 'https://my.treedis.com/tour/e-67a61a8d',
    galleryType: 'galleryE',
    hasVideo: true,
    galleryCount: 23,
    floorPlanImage: 'floorplanE',
  },
  {
    building: 'B2',
    number: 68,
    type: 'A1',
    floor: 13,
    rooms: 4,
    area: 92,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_A1_select_floor13',
    nrId: 106,
    tourUrl: 'https://my.treedis.com/tour/a1-42e35d92',
    galleryType: 'galleryA1',
    hasVideo: true,
    galleryCount: 18,
    floorPlanImage: 'floorplanA1',
  },
  {
    building: 'B2',
    number: 69,
    type: 'E3',
    floor: 13,
    rooms: 5,
    area: 124,
    balconyArea: 42,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_E3_select_floor13',
    nrId: 107,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    hasVideo: false,
    galleryCount: 1,
    floorPlanImage: 'floorplanE3',
  },
  {
    building: 'B2',
    number: 70,
    type: 'E',
    floor: 13,
    rooms: 5,
    area: 124,
    balconyArea: 45,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_E_select_floor13',
    nrId: 108,
    tourUrl: 'https://my.treedis.com/tour/e-67a61a8d',
    galleryType: 'galleryE',
    hasVideo: true,
    galleryCount: 23,
    floorPlanImage: 'floorplanE',
  },
  {
    building: 'B2',
    number: 72,
    type: 'C-4',
    floor: 13,
    rooms: 4,
    area: 106,
    balconyArea: 24,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_C-4_select_floor13',
    nrId: 109,
    tourUrl: 'https://my.treedis.com/tour/c4',
    galleryType: 'galleryC4',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplanC4',
  },
  {
    building: 'B2',
    number: 74,
    type: 'A1',
    floor: 14,
    rooms: 4,
    area: 92,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_A1_select_floor14',
    nrId: 110,
    tourUrl: 'https://my.treedis.com/tour/a1-42e35d92',
    galleryType: 'galleryA1',
    hasVideo: true,
    galleryCount: 18,
    floorPlanImage: 'floorplanA1',
  },
  {
    building: 'B2',
    number: 75,
    type: 'E3',
    floor: 14,
    rooms: 5,
    area: 124,
    balconyArea: 42,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_E3_select_floor14',
    nrId: 111,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    hasVideo: false,
    galleryCount: 1,
    floorPlanImage: 'floorplanE3',
  },
  {
    building: 'B2',
    number: 77,
    type: 'A-3',
    floor: 14,
    rooms: 3,
    area: 84,
    balconyArea: 15,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_A-3_select_floor14',
    nrId: 112,
    tourUrl: 'https://my.treedis.com/tour/a3',
    galleryType: 'galleryA3',
    hasVideo: true,
    galleryCount: 11,
    floorPlanImage: 'floorplanA3',
  },
  {
    building: 'B2',
    number: 78,
    type: 'C-4',
    floor: 14,
    rooms: 4,
    area: 106,
    balconyArea: 24,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_C-4_select_floor14',
    nrId: 113,
    tourUrl: 'https://my.treedis.com/tour/c4',
    galleryType: 'galleryC4',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplanC4',
  },
  {
    building: 'B2',
    number: 80,
    type: 'A1',
    floor: 15,
    rooms: 4,
    area: 92,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_A1_select_floor15',
    nrId: 114,
    tourUrl: 'https://my.treedis.com/tour/a1-42e35d92',
    galleryType: 'galleryA1',
    hasVideo: true,
    galleryCount: 18,
    floorPlanImage: 'floorplanA1',
  },
  {
    building: 'B2',
    number: 81,
    type: 'E3',
    floor: 15,
    rooms: 5,
    area: 124,
    balconyArea: 42,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_E3_select_floor15',
    nrId: 115,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    hasVideo: false,
    galleryCount: 1,
    floorPlanImage: 'floorplanE3',
  },
  {
    building: 'B2',
    number: 83,
    type: 'A-3',
    floor: 15,
    rooms: 3,
    area: 84,
    balconyArea: 15,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_A-3_select_floor15',
    nrId: 116,
    tourUrl: 'https://my.treedis.com/tour/a3',
    galleryType: 'galleryA3',
    hasVideo: true,
    galleryCount: 11,
    floorPlanImage: 'floorplanA3',
  },
  {
    building: 'B2',
    number: 84,
    type: 'C-4',
    floor: 15,
    rooms: 4,
    area: 106,
    balconyArea: 24,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_C-4_select_floor15',
    nrId: 117,
    tourUrl: 'https://my.treedis.com/tour/c4',
    galleryType: 'galleryC4',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplanC4',
  },
  {
    building: 'B2',
    number: 85,
    type: 'C-4',
    floor: 16,
    rooms: 4,
    area: 106,
    balconyArea: 24,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_C-4_select_floor16',
    nrId: 118,
    tourUrl: 'https://my.treedis.com/tour/c4',
    galleryType: 'galleryC4',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplanC4',
  },
  {
    building: 'B2',
    number: 86,
    type: 'A1',
    floor: 16,
    rooms: 4,
    area: 92,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_A1_select_floor16',
    nrId: 119,
    tourUrl: 'https://my.treedis.com/tour/a1-42e35d92',
    galleryType: 'galleryA1',
    hasVideo: true,
    galleryCount: 18,
    floorPlanImage: 'floorplanA1',
  },
  {
    building: 'B2',
    number: 87,
    type: 'E3',
    floor: 16,
    rooms: 5,
    area: 124,
    balconyArea: 42,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_E3_select_floor16',
    nrId: 120,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    hasVideo: false,
    galleryCount: 1,
    floorPlanImage: 'floorplanE3',
  },
  {
    building: 'B2',
    number: 90,
    type: 'C-4',
    floor: 16,
    rooms: 4,
    area: 106,
    balconyArea: 24,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_C-4_select_floor16',
    nrId: 121,
    tourUrl: 'https://my.treedis.com/tour/c4',
    galleryType: 'galleryC4',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplanC4',
  },
  {
    building: 'B2',
    number: 91,
    type: 'C-4',
    floor: 17,
    rooms: 4,
    area: 106,
    balconyArea: 24,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_C-4_select_floor17',
    nrId: 122,
    tourUrl: 'https://my.treedis.com/tour/c4',
    galleryType: 'galleryC4',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplanC4',
  },
  {
    building: 'B2',
    number: 92,
    type: 'A1',
    floor: 17,
    rooms: 4,
    area: 92,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_A1_select_floor17',
    nrId: 123,
    tourUrl: 'https://my.treedis.com/tour/a1-42e35d92',
    galleryType: 'galleryA1',
    hasVideo: true,
    galleryCount: 18,
    floorPlanImage: 'floorplanA1',
  },
  {
    building: 'B2',
    number: 93,
    type: 'E3',
    floor: 17,
    rooms: 5,
    area: 124,
    balconyArea: 42,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_E3_select_floor17',
    nrId: 124,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    hasVideo: false,
    galleryCount: 1,
    floorPlanImage: 'floorplanE3',
  },
  {
    building: 'B2',
    number: 96,
    type: 'C-4',
    floor: 17,
    rooms: 4,
    area: 106,
    balconyArea: 24,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_C-4_select_floor17',
    nrId: 125,
    tourUrl: 'https://my.treedis.com/tour/c4',
    galleryType: 'galleryC4',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplanC4',
  },
  {
    building: 'B2',
    number: 98,
    type: 'A1',
    floor: 18,
    rooms: 4,
    area: 92,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_A1_select_floor18',
    nrId: 126,
    tourUrl: 'https://my.treedis.com/tour/a1-42e35d92',
    galleryType: 'galleryA1',
    hasVideo: true,
    galleryCount: 18,
    floorPlanImage: 'floorplanA1',
  },
  {
    building: 'B2',
    number: 99,
    type: 'E3',
    floor: 18,
    rooms: 5,
    area: 124,
    balconyArea: 42,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_E3_select_floor18',
    nrId: 127,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    hasVideo: false,
    galleryCount: 1,
    floorPlanImage: 'floorplanE3',
  },
  {
    building: 'B2',
    number: 102,
    type: 'C-4',
    floor: 18,
    rooms: 4,
    area: 106,
    balconyArea: 24,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_C-4_select_floor18',
    nrId: 128,
    tourUrl: 'https://my.treedis.com/tour/c4',
    galleryType: 'galleryC4',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplanC4',
  },
  {
    building: 'B2',
    number: 103,
    type: 'C-4',
    floor: 19,
    rooms: 4,
    area: 106,
    balconyArea: 24,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_C-4_select_floor19',
    nrId: 129,
    tourUrl: 'https://my.treedis.com/tour/c4',
    galleryType: 'galleryC4',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplanC4',
  },
  {
    building: 'B2',
    number: 104,
    type: 'A1',
    floor: 19,
    rooms: 4,
    area: 92,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_A1_select_floor19',
    nrId: 130,
    tourUrl: 'https://my.treedis.com/tour/a1-42e35d92',
    galleryType: 'galleryA1',
    hasVideo: true,
    galleryCount: 18,
    floorPlanImage: 'floorplanA1',
  },
  {
    building: 'B2',
    number: 105,
    type: 'E3',
    floor: 19,
    rooms: 5,
    area: 124,
    balconyArea: 42,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_E3_select_floor19',
    nrId: 131,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    hasVideo: false,
    galleryCount: 1,
    floorPlanImage: 'floorplanE3',
  },
  {
    building: 'B2',
    number: 107,
    type: 'A-3',
    floor: 19,
    rooms: 3,
    area: 84,
    balconyArea: 15,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_A-3_select_floor19',
    nrId: 132,
    tourUrl: 'https://my.treedis.com/tour/a3',
    galleryType: 'galleryA3',
    hasVideo: true,
    galleryCount: 11,
    floorPlanImage: 'floorplanA3',
  },
  {
    building: 'B2',
    number: 108,
    type: 'C-4',
    floor: 19,
    rooms: 4,
    area: 106,
    balconyArea: 24,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_C-4_select_floor19',
    nrId: 133,
    tourUrl: 'https://my.treedis.com/tour/c4',
    galleryType: 'galleryC4',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplanC4',
  },
  {
    building: 'B2',
    number: 109,
    type: 'C-4',
    floor: 20,
    rooms: 4,
    area: 106,
    balconyArea: 24,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_C-4_select_floor20',
    nrId: 134,
    tourUrl: 'https://my.treedis.com/tour/c4',
    galleryType: 'galleryC4',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplanC4',
  },
  {
    building: 'B2',
    number: 110,
    type: 'A1',
    floor: 20,
    rooms: 4,
    area: 92,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_A1_select_floor20',
    nrId: 135,
    tourUrl: 'https://my.treedis.com/tour/a1-42e35d92',
    galleryType: 'galleryA1',
    hasVideo: true,
    galleryCount: 18,
    floorPlanImage: 'floorplanA1',
  },
  {
    building: 'B2',
    number: 111,
    type: 'E3',
    floor: 20,
    rooms: 5,
    area: 124,
    balconyArea: 42,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_E3_select_floor20',
    nrId: 136,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    hasVideo: false,
    galleryCount: 1,
    floorPlanImage: 'floorplanE3',
  },
  {
    building: 'B2',
    number: 116,
    type: 'P4',
    floor: 21,
    rooms: 6,
    area: 191,
    balconyArea: 108,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B2_P4_select_floor21',
    nrId: 137,
    tourUrl: undefined,
    galleryType: 'gallerytype',
    hasVideo: false,
    galleryCount: 1,
    floorPlanImage: 'floorplanP4',
  },
];
